import { Reducer, AnyAction } from 'redux';
import { ErrorMessage } from '../../common/constants/errorMessage';
import { Exception } from '../../common/constants/exception';

export interface ErrorState {
  loadInvoiceError: ErrorMessage;
  loadInvoiceFailure: ErrorMessage;
  getContactError: ErrorMessage;
  submitPaymentError: ErrorMessage;
  savePaymentMethodError: ErrorMessage;
  errorModalOpen: boolean;
  deletePaymentMethodError: ErrorMessage;
  reCaptchaFailure: ErrorMessage;
  loadPDFInvoiceFailure: ErrorMessage;
}

export const initialState: ErrorState = {
  loadInvoiceError: null,
  loadInvoiceFailure: null,
  getContactError: null,
  submitPaymentError: null,
  savePaymentMethodError: null,
  errorModalOpen: false,
  deletePaymentMethodError: null,
  reCaptchaFailure: null,
  loadPDFInvoiceFailure: null
};

export const errorMessageReducer: Reducer<ErrorState> = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case 'LOAD_INVOICE_NOT_FOUND':
    case 'LOAD_INVOICE_FORBIDDEN':
      return { ...state,
        loadInvoiceError: buildErrorMessage('No invoice matches this search. Please try again, or reach out for assistance.', action.payload.error),
        reCaptchaFailure: null };
    case 'RE_AUTHENTICATE':
      return { ...state, reCaptchaFailure: buildErrorMessage('Captcha UnAutheticated.', null) };
    case 'LOAD_INVOICE_FAILURE':
      return { ...state,
        loadInvoiceFailure: buildErrorMessage('Failed to get invoice.', action.payload.error),
        errorModalOpen: true,
        reCaptchaFailure: null };
    case 'LOAD_INVOICE_NOT_USD':
      return { ...state,
        loadInvoiceError: buildErrorMessage('Only USD invoices can be paid through the payment portal currently.', action.payload.error),
        reCaptchaFailure: null };
    case 'LOAD_INVOICE_VALIDATION_ERROR':
      return { ...state,
        loadInvoiceError: buildErrorMessage(action.payload.error.response.data?.responseStatus?.message, action.payload.error),
        reCaptchaFailure: null };
    case 'ERROR_MODAL_CLOSE':
      return { ...state, errorModalOpen: false };
    case 'GET_CONTACT_FAILURE':
      return { ...state, getContactError: buildErrorMessage('Failed to get contact', action.payload.error) };
    case 'SUBMIT_PAYMENT_FAILURE':
      return { ...state,
        submitPaymentError: buildErrorMessage('The payment was not submitted successfully. Please try again or reach out for assistance.', action.payload.error),
        reCaptchaFailure: null };
    case 'SAVE_PAYMENT_METHOD_FAILURE':
      return { ...state, savePaymentMethodError: buildErrorMessage('Unable to save payment method', action.payload.error),
        errorModalOpen: true,
        reCaptchaFailure: null };
    case 'DISMISS_PAYMENT_ERROR':
      return { ...state,
        submitPaymentError: null,
        reCaptchaFailure: null };
    case 'LOAD_INVOICE_PENDING':
    case 'GET_CONTACT_PENDING':
    case 'SAVE_PAYMENT_METHOD':
    case 'SUBMIT_PAYMENT_PENDING':
      return initialState;
    case 'DELETE_PAYMENT_METHOD_FAILURE':
      return { ...state, deletePaymentMethodError: buildErrorMessage('Failed to delete payment method', action.payload) };
    case 'DISMISS_PAYMENT_METHOD_ERROR':
      return { ...state, deletePaymentMethodError: null };
    case 'LOAD_PDF_INVOICE_FAILURE':
      return { ...state, loadPDFInvoiceFailure: buildErrorMessage('Failed to get PDF for an invoice', action.payload.error) };
    default:
      return state;
  }
};

function buildErrorMessage(displayMessage: string, error: Exception) {
  if (error && error.response && error.response.data && error.response.data.responseStatus) {

    return new ErrorMessage(
      displayMessage,
      error.response.data
    );
  }
  return new ErrorMessage(displayMessage, error);
}
